//import api from '@/modules/axios'
import globalConfig from '@/config/index'

import axios from 'axios'

axios.defaults.withCredentials = true
let obj = {
    data: { h: 1 },
    params: { h: 2 },
    h: 'qweq',
    headers: {
        withCredentials: true,
        kakos: true
    },
    withCredentials: true
}

export default {
    propagateLegacySessionXhr() {
        const xhr = new XMLHttpRequest()
        xhr.open('POST', globalConfig.regruLegacySessionUrl)
        xhr.withCredentials = true
        return xhr
    },
    signUserLoginXhr() {
        const xhr2 = new XMLHttpRequest()
        xhr2.open('GET', globalConfig.regruSignUserLoginUrl)
        xhr2.withCredentials = true
        return xhr2
    },
    propagateLegacySession() {
        return axios(globalConfig.regruLegacySessionUrl, {
            method: 'post',
            withCredentials: true
        })

        /*  return api.post(
            globalConfig.regruLegacySessionUrl,obj
        )*/
    },
    signUserLogin() {
        axios(globalConfig.regruSignUserLoginUrl, {
            method: 'post',
            withCredentials: true
        })
        /*  return api.get(
            globalConfig.regruSignUserLoginUrl,obj
        )*/
    }
}
